/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable indent */
import React, { useState, useEffect } from 'react';
import pako from 'pako';
import $ from 'jquery';
import { Box, Modal, Grid, Tooltip, IconButton, Backdrop, CircularProgress, Avatar } from '@mui/material';
import Draggable from 'react-draggable';
import CloseIcon from '@mui/icons-material/Close';
// url helper
import { getAdminData } from '../../shared/api/url-helper';
// Depenediencies
import WelcomeTable from './WelcomeTable';

import { defaultModalOptions } from '../../shared/constantVariable';
import Notification from '../../shared/notification-modal';
import { admingrtArrow } from '../../shared/assets/images';
import './admin.scss';
import AdminTable, { handleAddRow } from './AdminTable';

const Admin_modal = (props) => {
  const { adminOption, handleCloseOption } = props;
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  const [fetchLoading, setFetchLoading] = useState(false);
  const [dbTransactionDetails, setDbTransactionDetails] = useState({});
  const [dbTableList, setdbTableList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentColumns, setCurrentColumns] = useState([]);
  const [currentRowData, setCurrentRowData] = useState([]);
  const [currentTableName, setTableName] = useState('');
  const [currentTablePK, setCurrentTablePK] = useState([]);  // PK : Primary Key
  const [isWelcomeScr, setWelcomeScr] = useState(true);  // Welcome screen
  const checkCustomHeader = true;
  const [, setSubmitBtnDisabled] = useState('yes');
  const [, setShowButtons] = useState(false);
  const getTableListData = (dbData) => {
    const dblist = Object.keys(dbData.db_tables_data);
    setdbTableList(dblist);
  };

  const setDbTransData = (content) => {
    setDbTransactionDetails(content);
    getTableListData(content);
  };
  const handleCallFromChild = (curTableName) => {
    const url = JSON.stringify({ 'operation_type': 'get_db_info' });
    getAdminData(url)
      .then((res) => {
        const compressedData = JSON.parse(res.data).compressed_data;
        // Convert the compressed data from Base64 to a Uint8Array
        const compressedDataUint8Array = Uint8Array.from(atob(compressedData), c => c.charCodeAt(0));
        // Decompress the data using pako
        let decompressedData;
        try {
          decompressedData = pako.inflate(compressedDataUint8Array, { to: 'string' });
        } catch (err) {
          console.error('Error decompressing data:', err);
        }
        decompressedData = JSON.parse(decompressedData);
        setDbTransData(decompressedData);
      })
      .catch(() => {
        setFetchLoading(false);
        setModalOption({
          ...defaultModalOptions,
          visible: true,
          title: 'Warning',
          message: 'Failed to fetch Admin record',
          yesOrNo: false,
          onNo: () => setModalOption(defaultModalOptions)
        });
      });

    const rowData = [];
    const row = dbTransactionDetails.db_tables_data[curTableName];
    const colName = Object.keys(dbTransactionDetails.db_tables_data[curTableName]);
    const rowCount = row[colName[0]].length;

    for (let i = 0; i < rowCount; i += 1) {
      const tempObj = {};
      for (let j = 0; j < colName.length; j += 1) {
        tempObj[colName[j]] = row[colName[j]][i];
      }
      rowData.push(tempObj);
    }
    setCurrentRowData(rowData);
  };
  useEffect(async () => {
    setFetchLoading(true);
    const url = JSON.stringify({ 'operation_type': 'get_db_info' });
    getAdminData(url)
      .then(async (res) => {
        setFetchLoading(false);
        const compressedData = JSON.parse(res.data).compressed_data;
        // Convert the compressed data from Base64 to a Uint8Array
        const compressedDataUint8Array = Uint8Array.from(atob(compressedData), c => c.charCodeAt(0));
        // Decompress the data using pako
        let decompressedData;
        try {
          decompressedData = pako.inflate(compressedDataUint8Array, { to: 'string' });
        } catch (err) {
          console.error('Error decompressing data:', err);
        }
        decompressedData = JSON.parse(decompressedData);
        setDbTransData(decompressedData);
        $('#input_num1_2').prop('title', 'Delete');
        $('#input_num1_2').attr('title', 'Delete');
      })
      .catch(() => {
        setFetchLoading(false);
        setModalOption({
          ...defaultModalOptions,
          visible: true,
          title: 'Warning',
          message: 'Failed to fetch Admin record:)',
          yesOrNo: false,
          onNo: () => setModalOption(defaultModalOptions)
        });
      });
  }, []);

  useEffect(() => {
    $('.admin-ag-grid-container .row_1 #input_num1_1').removeClass('admin-editok-icon');
    $('.admin-ag-grid-container .row_1 #input_num1_1').addClass('admin-edit-icon');
  }, [currentRowData]);

  const handleToggle = () => {
    $('.admin-tableList').toggleClass('hideAndShow');
    $('.arrow').toggleClass('rotateArrow');
    $('#arrowPos').toggleClass('admin-arw-container-left');
    $('.admin-ag-grid-container').toggleClass('admin-ag-grid-container-right');
  };

  // Table list onClick listener
  const getCurrentTableData = (index, curTableName) => {
    setShowButtons(true);
    // set welcome screen to false
    setWelcomeScr(false);

    setTableName(curTableName);
    // Highlight Selected table name
    document.querySelectorAll('[class^=adminTableList]').forEach((ele) => {
      ele.classList.remove('selcted');
    });
    $(`[class=adminTableList${index}]`).addClass('selcted');
    // get the primary key
    const primaryKeys = dbTransactionDetails.primary_key_list[`${curTableName}`];
    setCurrentTablePK(primaryKeys);
    setIsLoading(true);
    setTimeout(() => {
      // get the required column format    db_tables_columns_order
      const col = dbTransactionDetails.db_tables_columns_order[curTableName].map(item => {
        if (item === primaryKeys) { // pinned the primary key column to the left of the table
          return { tag: `${item}`, hdata: `${item}`, datatype: '', disabled: true };
        }
        return { tag: `${item}`, hdata: `${item}`, datatype: '', disabled: true };
      });
      // action column merge first 2 header
      setCurrentColumns(col); // propertiex array
      // get the required row format
      const rowData = [];
      const row = dbTransactionDetails.db_tables_data[curTableName];
      const colName = Object.keys(dbTransactionDetails.db_tables_data[curTableName]);
      const rowCount = row[colName[0]].length;

      for (let i = 0; i < rowCount; i += 1) {
        const tempObj = {};
        for (let j = 0; j < colName.length; j += 1) {
          tempObj[colName[j]] = row[colName[j]][i];
        }
        rowData.push(tempObj);
      }
      setCurrentRowData(rowData);
      setIsLoading(false);
    }, 500);
  };

  return (
    <>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        style={{
          background: '#d9dbde5c',
        }}
        open={fetchLoading}
      >
        <CircularProgress color="inherit" style={{ color: '#4b93f4' }} />
      </Backdrop>
      <Notification
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 999 }}
        options={modalOption}
        handleClose={() => setModalOption(defaultModalOptions)}
      />
      <Draggable handle='.admin-header-grid'
        cancel='.admin-tableGrid .MuiTableHead-root, .MuiInputBase-root, .no-drag'
      >
        <Modal
          hideBackdrop  //  prevent closing modal when clicked outside
          open={adminOption}
          onClose={handleCloseOption}
          aria-labelledby='child-modal-title'
          aria-describedby='child-modal-description'
          className='admin-modal'
        >
          <Box className='admin-box admin-width'>
            <Grid container className='admin-grid-container admin-header-grid'>
              <Grid item xs={12} className='admin-header-grid'>
                <div className='admin-header-text' >
                  <div>Admin Dashboard</div>
                </div>
                <div className='admin-close-icon no-drag'>
                  <Tooltip title='Close'>
                    <IconButton
                      aria-label='save'
                      onClick={handleCloseOption}
                      size='large'
                      className='close-icon'
                    >
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </div>
              </Grid>
              <Grid item xs={12} >
                <div className="admin-flex-container">
                  {!fetchLoading &&
                    <div className='admin-tableList dbTableListBox'>
                      <div className='admin-header-text' style={{ 'marginLeft': '0px', bcolor: 'black', 'color': '#FFF' }}>Tables</div>
                      <ul id='adminList' data-tag='channelList' style={{
                        'maxHeight': '81vh', 'overflowY': 'auto', 'paddingLeft': '0px',
                        'marginTop': '0.5px', 'fontSize': '14px', 'color': '#2C2C2C',
                        'fontFamily': 'sans W4SeLig !important', 'width': '34.5vh'
                      }}>
                        {dbTableList && dbTableList.map((value, index) => (   // Array name has been changed
                          <li key={index} className={`adminTableList${index}`}
                            onClick={() => getCurrentTableData(index, value)} > {value}</li>
                        ))}
                      </ul>
                    </div>
                  }
                  {!fetchLoading &&
                    <div id='arrowPos' className='admin-arw-container-right'>
                      <Avatar sx={{ 'backgroundColor': '#FFF' }} className='arrow' onClick={handleToggle}>
                        <div style={{ 'color': '#00AEC7' }}>
                          <img src={admingrtArrow} />
                        </div>
                      </Avatar>
                    </div>
                  }
                  <div className='admin-tableContainer' style={{ 'maxHeight': '83vh' }}>
                    {currentTableName.length > 0 &&
                      <div className='admin-tableName-contanier'>
                        <span className='admin-tableName'>{currentTableName} Table</span>
                        <span className='d-none' onClick={() => handleAddRow()}>+Add Row</span>
                      </div>
                    }
                    <div className='admin-tableGrid'>
                      {isWelcomeScr ? <WelcomeTable fetchLoading={fetchLoading} /> :
                        <AdminTable currentRowData={currentRowData}
                          currentColumns={currentColumns} currentTableName={currentTableName} currentTablePK={currentTablePK}
                          dbTransactionDetails={dbTransactionDetails} setDbTransactionDetails={setDbTransactionDetails}
                          handleCloseOption={handleCloseOption}
                          setSubmitBtnDisabled={setSubmitBtnDisabled}
                          checkCustomHeader={checkCustomHeader}
                          headerData={currentColumns}
                          isLoading={isLoading}
                          handleCallFromChild={handleCallFromChild}
                        />
                      }
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Box>
        </Modal>
      </Draggable>
    </>
  );
};
export default Admin_modal;